import ar from './ar'
import de from './de'
import en from './en'
import es from './es'
import fr from './fr'
import gu from './gu'
import hi from './hi'
import id from './id'
import it from './it'
import ja from './ja'
import km from './km'
import ko from './ko'
import ms from './ms'
import pl from './pl'
import pt from './pt'
import th from './th'
import tl from './tl'
import tr from './tr'
import vi from './vi'
import zh from './zh'
import zh_HK from './zh_HK'
import zh_TW from './zh_TW'

const locale = {
    id,
    en,
    hi,
    gu,
    es,
    de,
    ar,
    fr,
    it,
    pt,
    ja,
    ko,
    zh,
    km,
    th,
    tl,
    tr,
    vi,
    ms,
    zh_TW,
    zh_HK,
    pl
}

export default locale
